import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import * as actions from 'store/actions';
import { faUser, faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SignUp from 'Flow2/components/AdvancedBox/AdvancedForm/SignUp/SignUp';
import * as cTypes from 'Flow2/components/AdvancedBox/AdvancedConfig/ConfigTypes';
import MessageService from 'Flow2/components/Services/MessageService/MessageService';
import "./SignIn.scss";

const SignIn = (props) => {
    const [userInputs, setUserInputs] = useState({});
    const [errors, setErrors] = useState({});
    const [isShow, setIsShow] = useState(false);
    const [data, setData] = useState(cTypes.SIGNIN_ITEMS);

    const fm = (id) => props.intl.formatMessage({ id });

    useEffect(() => {
        if (props.data) setData(props.data);
    }, [props.data, props.lg]);

    const handleSignIn = (e) => {
        e.preventDefault();
        let params = [];

        cTypes.SIGNIN_ITEMS.forEach((item) => {
            params.push(userInputs[item.name]);
        })
        if (params && params.some(p => !p)) {
            console.log("LOGS: handleSignIn Errors", errors)
        } else {
            props.onAuth(params[0], params[1], true, props.intl.formatMessage);
            props.onClose();
        }
    }

    const onInput = ({ e, item }) => {
        const { value } = e.target;
        let isValid = true;
        if (item.isRequired) {
            if (!value || !value.trim()) setErrors({ ...errors, [item.name]: true });
            else setErrors({ ...errors, [item.name]: false });
        }
        if (item && item.rules && props.checkValidity) {
            isValid = props.checkValidity(value, item.rules);
            if (!isValid) setErrors({ ...errors, [item.name]: true });
            else setErrors({ ...errors, [item.name]: false });
        }
        setUserInputs((prev) => {
            return ({ ...prev, [item.name]: value || '' });
        });
    }

    const getHeadline = () => {
        let txt = fm('login.signup');
        if (props.heading) txt = props.heading;
        return (
            <h1 className="signin-heading">
                <FontAwesomeIcon icon={faUser} />
                {txt}
            </h1>
        )
    }

    const getSubTxt = () => {
        if (props.subtxtItems) {
            return props.subtxtItems.map(item => {
                if (item.type === cTypes.LINK_BTN) {
                    return (
                        <div>
                            {fm(item.before)}
                            <span className="signin-blue"
                                onClick={item.isRegister ? onRegister : null}>
                                {fm(item.intl)}
                            </span>
                            {fm(item.after)}
                        </div>
                    )
                }
                return (<div>{fm(item.intl)}</div>)
            })
        }
        return null;
    }


    const onForgot = () => {
        MessageService.infoMsg({
            formatMessage: props.intl.formatMessage,
            titleIntl: "page.auth.link.forgot", textIntl: "page.auth.forgot.message"
        });
    }

    const onRegister = () => {
        setIsShow(true);
    }

    const showBottom = () => {
        let data = cTypes.SIGNIN_BOTTOM_ITEMS;
        if (props.bottomItems) data = props.bottomItems;
        return data.map((item, i) => {
            if (item.link) {
                return (
                    <div key={`signin${i}${item.name}`} className="signin-register-link">
                        {item.before && fm(item.before)}
                        <a href={item.link}>{item.after ? fm(item.after) : fm(item.intl)}</a>
                    </div>)
            }
            let onItemClick;
            if (item.isRegister) onItemClick = onRegister;
            if (item.isForgot) onItemClick = onForgot;
            return (
                <div key={`signin${i}${item.name}`} onClick={onItemClick}
                    className="signin-register-item">
                    {fm(item.intl)}
                </div>
            )
        })
    }

    const showForm = () => {
        return (
            <>
                <div className="signin-top">
                    {getHeadline()}
                    <div className="signin-subtxt">
                        {getSubTxt()}
                    </div>
                </div>
                <form className="signin-form" onSubmit={handleSignIn}>
                    {data.map((item, i) => (
                        <div className="signin-group" key={`signuppage-${i}${item.name}`}>
                            <label htmlFor={item.name} className="signin-label">
                                {fm(item.intl)}
                                <img src={item.icon} />
                            </label>
                            <input className={`signin-input ${errors[item.name] ? ' signin-red' : ''}`}
                                type={item.type}
                                placeholder={item.placeholder ? item.placelholder : fm(item.intl)}
                                required={item.isRequired} id={item.name} onChange={(e) => onInput({ e, item })}
                                value={userInputs[item.name]} />
                        </div>
                    ))}
                    <button className="signin-btn">
                        <FontAwesomeIcon icon={faSignInAlt} />{fm('app.login')}
                    </button>
                    <div className="signin-register">
                        {showBottom()}
                    </div>

                </form>
            </>
        )
    }

    const showDefaultForm = () => {
        return (
            <div className="signin-wrapper">
                {showForm()}
            </div>
        )
    }

    const showFormWithInfo = () => {
        return (
            <div className="signin-xl-wrapper">
                <div className="signin-left">
                    {props.infoItems.map(item => {
                        if (item.type === cTypes.HEADLINE) return <h2>{fm(item.intl)}</h2>
                        if (item.type === cTypes.LINK) {
                            return (
                                <div className="signin-linkbox">
                                    <a className="signin-link" href={`mailto:${item.link}`}>{item.link}</a>
                                    <span>{fm(item.intl)}</span>
                                </div>
                            )
                        }
                        if (item.type == cTypes.BREAKLINE) return <div className="signin-breakline"></div>
                        return <p>{fm(item.intl)}</p>
                    })}
                </div>
                <div className="signin-right">
                    {showForm()}
                </div>
            </div>
        )
    }

    return (
        <>
            <div className="signin-hero-bg">
                <div className="signin-box">
                    {props.infoItems ? showFormWithInfo() : showDefaultForm()}
                </div>
            </div>
            {isShow && (
                <SignUp isOpened={isShow} heading={fm('auth.welcome')}
                    logo={props.logo} withLoginBtn={true} data={cTypes.SIGNUP_TDK_ITEMS}
                    subtxtItems={cTypes.SIGNUP_TDK_SUBTXT_ITEMS}
                    checkValidity={props.checkValidity}
                    onClose={() => setIsShow(false)} />)}
        </>
    )
}

const mapStateToProps = (state) => ({
    // authObjects: state.auth.authObjects,
});

const mapDispatchToProps = (dispatch) => ({
    onAuth: (user, password, isSignup, formatMessage) => dispatch(actions.auth(user, password, isSignup, formatMessage)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SignIn));
